// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"313c112f","292":"f9383fb2","628":"ec381c4f","644":"7aaf9c6e","694":"54b9f902","989":"84175915"}[chunkId] + ".chunk.css";
};